/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { ElementRef, Component, Input, Inject, OnInit } from '@angular/core';
import { IcepanelService } from './icepanel.service';
import { IcepanelComponent } from './icepanel.component';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, IcepanelsectionSettings, SECTION_CONTROL_ALIGNMENT, IcecontrolPermission, IcepanelgroupSettings, IcemattableSettings, IceResponsiveMattableSettings } from '../../components/models/icesettings';
import { userTypes } from '../../login/login.config';

@Component({
    selector: 'icesection',
    templateUrl: './icesection.component.html',
    styleUrls: ['./icesection.component.scss']
})
export class IcesectionComponent implements OnInit {
    // Input Members
    @Input() panelTag: string = "";
    @Input() sectionTag: string = "";
    @Input() properties: any = {};
    @Input() groups: any[];
    @Input() controls: IcecontrolSettings[];
    @Input() tables: any[];
    @Input() panelKey: string = "";
    @Input() sectionSettings: IcepanelsectionSettings = null;

    // Element Members
    classList: string = "";
    id: string = "";
    permission: IcecontrolPermission = null;

  loaderMode: "'indeterminate'";
  loaderValue: 10;

    constructor(private targetElement: ElementRef,
        private panelSvc: IcepanelService,
        private parent: IcepanelComponent) { }

    /////////////////////
    // lifecycle hooks //
    /////////////////////

    ngOnInit() {
        this.permission = this.sectionSettings.permissions ? this.sectionSettings.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);
        let elem: HTMLElement = this.panelSvc.getSectionElement(this.targetElement.nativeElement);
        this.setPermission();

        if (Iceutility.isdefined(elem)) {
            elem.setAttribute("iSection", this.sectionTag);

            if (Iceutility.isdefined(this.properties) &&
                Iceutility.isdefined(this.properties.class) &&
                this.properties.class.length > 0) {
                for (let iclass = 0; iclass < this.properties.class.length; iclass++) {
                    let className = this.properties.class[iclass];
                    if (!Iceutility.isdefined(className) || className.trim() === "") {
                        continue;
                    }

                    elem.classList.add(className);
                }
            }

            if (Iceutility.isdefined(this.properties) &&
                Iceutility.isdefined(this.properties.styles)) {

                var styleObj = this.properties.styles;
                for (var key in styleObj) {
                    if (styleObj.hasOwnProperty("width")) {
                        elem.style.width = styleObj[key];
                    }
                }
            }

            this.id = this.panelTag + "_Panel_" + this.panelKey + "_" + this.sectionTag + "_" + this.panelKey;
        }
  }

    //////////////////////
    // public functions //
    //////////////////////

    // To do: eliminate this event
    iceButtonClick(settings) {
        if (settings && settings.tsEvents && typeof settings.tsEvents.onClick === 'function') {
            settings.tsEvents.onClick(settings);
        }
    }

  getSectionStyle() {
    return this.sectionSettings.getControlAlignment() == SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical ? {
      display: 'flex', 'align-items': 'center',
      width:
        this.sectionSettings.properties
          && this.sectionSettings.properties.styles
          && this.sectionSettings.properties.styles.width ? this.sectionSettings.properties.styles.width : 'inherit'
        } : {
        display: 'inline-flex', 'text-align': 'left', 'align-items': 'left', 'vertical-align': 'bottom',
        width:
          this.sectionSettings.properties
            && this.sectionSettings.properties.styles
            && this.sectionSettings.properties.styles.width ? this.sectionSettings.properties.styles.width : 'inherit'
      };
  }

  getShow(): boolean {
    return this.sectionSettings.getShow();
  }

  isLoading(): boolean {
    return this.sectionSettings.isLoading();
  }

  getColumnClass(settings) {
    return settings && settings.properties && settings.properties.class ? settings.properties.class : { 'col-lg-12': true };
  }

  hasAccess(): boolean {
    return (this.permission.default_access !== userTypes.USER_FEATURE_ACCESS.ufaNone || this.permission.feature === userTypes.USER_FEATURES.ufNone);
  }

  getMatTableType(tbl: IcemattableSettings) {
    return tbl.doInlineEdit ? (Iceutility.isMobileDevice() ? "IceMattableResponsiveMobileEdit" : "IceMattableResponsiveDesktopEdit") : "IceMattableResponsive";
  }

  ///////////////////////
  // private functions //
  ///////////////////////

  private setPermission(): void {
    // pass on section permission down to controls, groups and tables
    let sectionPermission = this.permission;
    if (this.controls && this.controls.length > 0) {
      this.controls.forEach(function (control: IcecontrolSettings) {
          control.permissions = control.permissions ? control.permissions : sectionPermission;
      });
    }

    if (this.groups && this.groups.length > 0) {
      this.groups.forEach(function (group: IcepanelgroupSettings) {
        group.permissions = group.permissions ? group.permissions : sectionPermission;

        // pass on the permission furthur down to tables as group contains tables
        if (group.tables && group.tables.length > 0) {
          group.tables.forEach(function (groupTable: IcemattableSettings) {
            groupTable.permissions = groupTable.permissions ? groupTable.permissions : sectionPermission;
          });
        }
      });
    }

    if (this.tables && this.tables.length > 0) {
      this.tables.forEach(function (table: IcemattableSettings) {
        table.permissions = table.permissions ? table.permissions : sectionPermission;
      });
    }
  }
}
